import styled from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';

const SubHeading = styled.h4`
  display: inline-block;
  height: 40px;
  line-height: 40px !important;
  padding: 0 16px;
  border: 1px solid ${Colors.black1};
  color: ${Colors.black1};
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ${FontStyles.text7};
  margin: 0 0 12px;
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${FontStyles.text5};
  margin: 0 0 16px;
`;

export default applyStyles(SubHeading)(pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/SubHeading/index.js